<div
    class="stat_box"
    [ngStyle]="{
        backgroundColor: cardBgColor,
        border: '1px solid' + cardBorderColor
    }"
>
    <div
        class="stat_box__content single-stats-box patrimoine-sim-card mb-25 w-100"
    >
        <div class="d-flex justify-content-between">
            <h1 [ngStyle]="{ color: countColor }">{{ pipeValue(count) }} {{ unit }}</h1>
            <h2 [ngStyle]="{ color: countColor }" class="pt-1" *ngIf="taux">
                {{ taux ?? 0 }}%
            </h2>
        </div>
        <h5 class="text-white text-end fw-semibold" style="margin:0px;" *ngIf="count2">
            {{ pipeValue(count2) }} {{ unit2 }}
        </h5>
        <h4 class="fw-semibold" [ngStyle]="{ color: legendColor, 'margin-top': count2 ? '10px' : '35px' }">
            {{ legend }}
        </h4>
    </div>
    <div class="stat_box__asset">
        <img [src]="icon" alt="" />
    </div>
</div>
